"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3588],{

/***/ 23100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export AdSlotBase */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41799);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48641);
/* harmony import */ var _config_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8002);




var AdSlotBase = function(param) {
    var data = param.data;
    var slot = data;
    if (!(slot === null || slot === void 0 ? void 0 : slot.slotId) || !_config_constants__WEBPACK_IMPORTED_MODULE_1__/* .ADSENSE_ID */ .jf) {
        return null;
    }
    var props = {};
    if (slot === null || slot === void 0 ? void 0 : slot.responsive) {
        props["data-full-width-responsive"] = "true";
    }
    if (slot === null || slot === void 0 ? void 0 : slot.layout) {
        props["data-ad-layout"] = slot === null || slot === void 0 ? void 0 : slot.layout;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        width: "100%",
        minHeight: (slot === null || slot === void 0 ? void 0 : slot.maxHeight) ? "".concat(slot === null || slot === void 0 ? void 0 : slot.maxHeight, "px") : "auto",
        my: {
            base: 4,
            md: 6
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ins", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                className: "adsbygoogle",
                style: {
                    display: "block",
                    marginLeft: "auto",
                    marginRight: "auto",
                    textAlign: "center"
                },
                "data-ad-client": "ca-pub-".concat(_config_constants__WEBPACK_IMPORTED_MODULE_1__/* .ADSENSE_ID */ .jf),
                "data-ad-slot": slot === null || slot === void 0 ? void 0 : slot.slotId,
                "data-ad-format": (slot === null || slot === void 0 ? void 0 : slot.format) || "auto"
            }, props)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: "(adsbygoogle = window.adsbygoogle || []).push({});"
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AdSlotBase);


/***/ }),

/***/ 21097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Image; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23887);





var Image = function(_param) {
    var imageStyle = _param.imageStyle, image = _param.image, hideCopyright = _param.hideCopyright, wrapperProps = _param.wrapperProps, description = _param.description, copyrightInside = _param.copyrightInside, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "imageStyle",
        "image",
        "hideCopyright",
        "wrapperProps",
        "description",
        "copyrightInside"
    ]);
    if (!imageStyle) return null;
    var showCopyright = !hideCopyright && image.copyright;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        className: "image-".concat(image.id),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                pos: "relative"
            }, wrapperProps), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Img */ .Ei, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                        htmlWidth: imageStyle.width,
                        htmlHeight: imageStyle.height,
                        src: imageStyle.url,
                        width: "100%",
                        loading: "lazy",
                        alt: image.alt || ""
                    }, props)),
                    showCopyright && copyrightInside && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                        pos: "absolute",
                        left: 0,
                        bottom: 0,
                        bg: "rgba(0,0,0, .4)",
                        color: "white",
                        p: 1,
                        fontSize: "xxs",
                        children: [
                            "Foto \xa9 ",
                            image.copyright
                        ]
                    })
                ]
            })),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                pt: 1,
                fontSize: "md",
                children: description
            }),
            showCopyright && !copyrightInside && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                fontSize: "xxs",
                children: [
                    "Foto \xa9 ",
                    image.copyright
                ]
            })
        ]
    });
};


/***/ }),

/***/ 45387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ StaticAdSlot; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context_PageContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40353);
/* harmony import */ var _AdSlotBase__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23100);




var StaticAdSlot = function(param) {
    var adKey = param.adKey;
    var ref;
    var pageContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context_PageContext__WEBPACK_IMPORTED_MODULE_2__/* .PageContext */ .z);
    if (!((ref = pageContext.adSlots) === null || ref === void 0 ? void 0 : ref[adKey])) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AdSlotBase__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        data: pageContext.adSlots[adKey]
    });
};


/***/ }),

/***/ 58005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ Metatags; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _config_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8002);
/* harmony import */ var _context_PageContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40353);





var Metatags = function(param) {
    var metatags = param.metatags;
    if (!metatags || !metatags.length) return null;
    var pageContext = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_context_PageContext__WEBPACK_IMPORTED_MODULE_4__/* .PageContext */ .z);
    var publicRuntimeConfig = _config_constants__WEBPACK_IMPORTED_MODULE_3__/* .PUBLIC_RUNTIME_CONFIG */ .Ls;
    var parsedMetatags = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var title = metatags.find(function(tag) {
            return tag.tag === "title";
        });
        var tags = metatags.filter(function(tag) {
            return tag.tag !== "title";
        }).map(function(tag) {
            return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createElement)(tag.tag, {
                key: JSON.stringify(tag),
                name: tag.attributes.name || undefined,
                content: tag.attributes.content || undefined,
                rel: tag.attributes.rel || undefined,
                href: tag.attributes.href || undefined,
                property: tag.attributes.property || undefined
            });
        });
        return {
            title: (title === null || title === void 0 ? void 0 : title.attributes.content) || "",
            tags: tags
        };
    }, [
        metatags
    ]);
    var canonicalUrl = undefined;
    if (pageContext.entity) {
        canonicalUrl = "".concat(publicRuntimeConfig.FRONTEND_URL).concat(pageContext.entity.url);
        if (pageContext.entity.url === "/home") {
            canonicalUrl = publicRuntimeConfig.FRONTEND_URL;
        }
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: parsedMetatags.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            }),
            parsedMetatags.tags
        ]
    });
};


/***/ }),

/***/ 3588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Article": function() { return /* reexport */ Article; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./src/components/Paragraph/ParagraphRenderer.tsx
var ParagraphRenderer = __webpack_require__(67025);
// EXTERNAL MODULE: ./src/utils/slugify.ts
var slugify = __webpack_require__(28590);
;// CONCATENATED MODULE: ./src/hooks/useTableOfContentLinks.ts


function useTableOfContentLinks(paragraphs) {
    return (0,react.useMemo)(function() {
        return paragraphs// @note: We use any type here because paragraph could be just empty
        .map(function(paragraph) {
            if (paragraph.__typename === "ParagraphText" && paragraph.addToTableOfContents && paragraph.headline) {
                return {
                    title: paragraph.headline,
                    anchor: (0,slugify/* default */.Z)(paragraph.headline) || ""
                };
            } else if ((paragraph.__typename === "ParagraphTextWithImage" || paragraph.__typename === "ParagraphInfoBox") && paragraph.textParagraph.addToTableOfContents && paragraph.textParagraph.headline) {
                return {
                    title: paragraph.textParagraph.headline,
                    anchor: (0,slugify/* default */.Z)(paragraph.textParagraph.headline)
                };
            }
            return null;
        }).filter(Boolean);
    }, [
        paragraphs
    ]);
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var dist_index_esm = __webpack_require__(47741);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var icon_dist_index_esm = __webpack_require__(52494);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/io5/IoClose.js
var IoClose = __webpack_require__(5981);
// EXTERNAL MODULE: ./src/utils/scrollToElement.ts
var scrollToElement = __webpack_require__(29556);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/io5/IoChevronDown.js
var IoChevronDown = __webpack_require__(21370);
;// CONCATENATED MODULE: ./src/components/Common/TableOfContents.tsx









var TableOfContents = function(_param) {
    var links = _param.links, onClick = _param.onClick, onClose = _param.onClose, showClose = _param.showClose, isSticky = _param.isSticky, mobileCutted = _param.mobileCutted, props = (0,_object_without_properties/* default */.Z)(_param, [
        "links",
        "onClick",
        "onClose",
        "showClose",
        "isSticky",
        "mobileCutted"
    ]);
    var ref = (0,react.useState)(false), showAll = ref[0], setShowAll = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        layerStyle: "shadowBox",
        pos: "relative"
    }, props), {
        children: [
            showClose && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.zx, {
                variant: "ghost",
                pos: "absolute",
                top: "5px",
                right: 0,
                zIndex: 14,
                onClick: onClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                    as: IoClose/* IoClose */.b
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                as: "div",
                variant: "boxTitle",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                    as: "span",
                    children: "Inhaltsverzeichnis"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* List */.aV, {
                pt: 3,
                color: "primaryDark",
                maxH: isSticky ? {
                    base: "calc(100vh - 8rem)",
                    md: "none"
                } : "none",
                overflowY: isSticky ? "auto" : "visible",
                children: links.map(function(link, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ListItem */.HC, {
                        display: {
                            base: mobileCutted && i >= 3 && !showAll ? "none" : "list-item",
                            md: "list-item"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "#".concat(link.anchor),
                            onClick: function(e) {
                                e.preventDefault();
                                (0,scrollToElement/* default */.Z)("#".concat(link.anchor));
                                onClick && onClick();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                display: "block",
                                as: "span",
                                py: 1,
                                _hover: {
                                    color: "primaryDarker",
                                    transition: "color .2s"
                                },
                                children: [
                                    i + 1,
                                    ". ",
                                    link.title
                                ]
                            })
                        })
                    }, link.anchor);
                })
            }),
            !showAll && mobileCutted && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                justifyContent: "center",
                mt: 3,
                pt: 3,
                borderTop: "1px solid",
                borderColor: "accent",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Button */.zx, {
                    size: "sm",
                    variant: "outlineBlue",
                    onClick: function() {
                        return setShowAll(true);
                    },
                    children: [
                        "Alle Inhalte ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                            as: IoChevronDown/* IoChevronDown */.C
                        })
                    ]
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/components/Common/Image.tsx
var Image = __webpack_require__(21097);
// EXTERNAL MODULE: ./src/components/Layout/Metatags.tsx
var Metatags = __webpack_require__(58005);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/index.esm.js
var hooks_dist_index_esm = __webpack_require__(39653);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/transition/dist/index.esm.js
var transition_dist_index_esm = __webpack_require__(71197);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/io5/IoListOutline.js
var IoListOutline = __webpack_require__(56739);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/io5/IoChevronUp.js
var IoChevronUp = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useWindowScroll.js + 3 modules
var useWindowScroll = __webpack_require__(57031);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useLockBodyScroll.js
var useLockBodyScroll = __webpack_require__(81341);
;// CONCATENATED MODULE: ./src/components/Common/StickyArticleButtons.tsx








var StickyArticleButtons = function(param) {
    var links = param.links, parentTocRef = param.tocRef;
    var ref = (0,useWindowScroll/* default */.Z)(), x = ref.x, y = ref.y;
    var ref1 = (0,hooks_dist_index_esm/* useDisclosure */.qY)(), isOpen = ref1.isOpen, onToggle = ref1.onToggle, onOpen = ref1.onOpen, onClose = ref1.onClose;
    var tocRef = (0,react.useRef)(null);
    (0,hooks_dist_index_esm/* useOutsideClick */.O3)({
        ref: tocRef,
        handler: function() {
            onClose();
        }
    });
    var scrollToTop = function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    var renderStickyButtons = (0,react.useMemo)(function() {
        if (parentTocRef.current) {
            var bounds = parentTocRef.current.getBoundingClientRect();
            return y > parentTocRef.current.offsetTop + bounds.height;
        }
        return false;
    }, [
        parentTocRef,
        y
    ]);
    (0,useLockBodyScroll/* default */.Z)(isOpen);
    (0,react.useEffect)(function() {
        if (!renderStickyButtons) {
            onClose();
        }
    }, [
        renderStickyButtons
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        display: {
            base: "block",
            md: "none"
        },
        children: [
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                pos: "fixed",
                bottom: 0,
                left: 0,
                right: 0,
                top: 0,
                bg: "rgba(255,255,255, .8)",
                zIndex: 14
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition_dist_index_esm/* Slide */.Mi, {
                direction: "bottom",
                in: renderStickyButtons,
                style: {
                    zIndex: 15
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                    p: 2,
                    ref: tocRef,
                    children: [
                        isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOfContents, {
                            mb: 4,
                            bg: "white",
                            links: links,
                            onClick: onClose,
                            showClose: true,
                            onClose: onClose,
                            isSticky: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Button */.zx, {
                                    variant: "roundBlue",
                                    size: "sm",
                                    px: 4,
                                    onClick: onToggle,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                            as: IoListOutline/* IoListOutline */.m,
                                            mr: 2,
                                            fontSize: "xl"
                                        }),
                                        "Inhaltsverzeichnis"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Button */.zx, {
                                    variant: "roundBlue",
                                    size: "sm",
                                    pl: 4,
                                    pr: 2,
                                    onClick: scrollToTop,
                                    children: [
                                        "Nach oben",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                            as: IoChevronUp/* IoChevronUp */.A,
                                            ml: 1,
                                            fontSize: "xl"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js + 1 modules
var parseISO = __webpack_require__(78420);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 27 modules
var format = __webpack_require__(8085);
;// CONCATENATED MODULE: ./src/components/Common/AuthorAndDate.tsx





var AuthorAndDate = function(param) {
    var authors = param.authors, date = param.date, _renderDate = param.renderDate, renderDate = _renderDate === void 0 ? true : _renderDate;
    var hasAuthors = authors && authors.length > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
            mt: 2,
            fontSize: "sm",
            children: [
                hasAuthors && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                            mr: 1,
                            children: "von"
                        }),
                        authors.map(function(author) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: author.url,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                        as: "a",
                                        textDecor: "underline",
                                        children: author.title
                                    })
                                })
                            }, author.id);
                        })
                    ]
                }),
                renderDate && date && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                    ml: hasAuthors ? 1 : 0,
                    children: [
                        "zuletzt aktualisiert ",
                        (0,format/* default */.Z)((0,parseISO/* default */.Z)(date), "dd.MM.yyyy")
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/Common/StaticAdSlot.tsx
var StaticAdSlot = __webpack_require__(45387);
;// CONCATENATED MODULE: ./src/components/Node/Article/Article.tsx











var Article = function(param) {
    var data = param.data;
    var ref;
    var tableOfContentLinks = useTableOfContentLinks(data.content);
    var tocRef = (0,react.useRef)(null);
    var renderSidebar = data.showTableOfContents || data.sidebarBlocks.length > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Metatags/* Metatags */.A, {
                metatags: data.metatags
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Container */.W2, {
                maxW: "container.main",
                py: 9,
                pos: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                        as: "h1",
                        color: "primaryDark",
                        children: data.headline
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthorAndDate, {
                        authors: data.authors,
                        date: data.updatedAt
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyArticleButtons, {
                        tocRef: tocRef,
                        links: tableOfContentLinks
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Grid */.rj, {
                        templateColumns: {
                            base: "repeat(12, minmax(0, 1fr))",
                            md: "repeat(12, minmax(0, 1fr))"
                        },
                        gap: {
                            base: 0,
                            md: 9
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* GridItem */.P4, {
                                colSpan: {
                                    base: 12,
                                    md: renderSidebar ? 8 : 12
                                },
                                children: [
                                    !data.hideImage && data.teaserImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                        py: 4,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                            borderRadius: "sm",
                                            image: data.teaserImage,
                                            imageStyle: data.teaserImage.imageStyle
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                        display: {
                                            base: "block",
                                            md: "none"
                                        },
                                        py: 6,
                                        ref: tocRef,
                                        children: data.showTableOfContents && /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOfContents, {
                                            links: tableOfContentLinks,
                                            mobileCutted: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ParagraphRenderer/* ParagraphRenderer */.W, {
                                        paragraphs: data.content,
                                        wrapperProps: {
                                            __css: {
                                                "&.ParagraphText:not(:first-child) > h2": {
                                                    mt: 2
                                                },
                                                "&.ParagraphLinks": {
                                                    mb: 6
                                                }
                                            }
                                        }
                                    })
                                ]
                            }),
                            renderSidebar && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* GridItem */.P4, {
                                pt: 4,
                                colSpan: {
                                    base: 12,
                                    md: 4
                                },
                                children: [
                                    data.showTableOfContents && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                        display: {
                                            base: "none",
                                            md: "block"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOfContents, {
                                            links: tableOfContentLinks
                                        })
                                    }),
                                    (ref = data.sidebarBlocks) === null || ref === void 0 ? void 0 : ref.map(function(block, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                            mt: 8,
                                            layerStyle: "shadowBox",
                                            children: [
                                                block.headline && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                                    mb: 4,
                                                    as: "div",
                                                    variant: "boxTitle",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                        as: "span",
                                                        children: block.headline
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ParagraphRenderer/* ParagraphRenderer */.W, {
                                                    paragraphs: block.content,
                                                    wrapperProps: {
                                                        py: 0
                                                    }
                                                })
                                            ]
                                        }, i);
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StaticAdSlot/* StaticAdSlot */.z, {
                        adKey: "end_of_content"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Node/Article/index.ts



/***/ }),

/***/ 67025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ ParagraphRenderer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48641);
/* harmony import */ var _config_entity_mapping__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51285);





var getWrapper = function(name, Component) {
    if (name === "container") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
            maxW: "container.main",
            children: Component
        });
    } else if (name === "containerSmall") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
            maxW: "container.small",
            children: Component
        });
    }
    return Component;
};
var ParagraphRenderer = function(param) {
    var paragraphs = param.paragraphs, wrapperProps = param.wrapperProps, paragraphWrappers = param.paragraphWrappers, getWrapperForParagraph = param.getWrapperForParagraph;
    if (!paragraphs) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        className: "paragraphs",
        children: paragraphs.map(function(paragraph, i) {
            var Component = _config_entity_mapping__WEBPACK_IMPORTED_MODULE_1__/* .EntityMapping */ .f[paragraph.__typename] || null;
            if (!Component) {
                console.warn("[ParagraphRenderer] Paragraph not found", paragraph.__typename);
                return null;
            }
            var InnerComponent = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
                data: paragraph
            });
            var OuterComponent = InnerComponent;
            if (paragraphWrappers) {
                if (paragraphWrappers[paragraph.__typename]) {
                    OuterComponent = getWrapper(paragraphWrappers[paragraph.__typename], InnerComponent);
                } else if (paragraphWrappers._all) {
                    OuterComponent = getWrapper(paragraphWrappers._all, InnerComponent);
                }
            }
            if (getWrapperForParagraph) {
                var wrapperName = getWrapperForParagraph(paragraph.__typename);
                if (wrapperName) {
                    OuterComponent = getWrapper(wrapperName, InnerComponent);
                }
            }
            if ("contentWidth" in paragraph) {
                if (paragraph.contentWidth === "small") {
                    OuterComponent = getWrapper("containerSmall", InnerComponent);
                }
            }
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                py: 3,
                className: paragraph.__typename,
                pos: "relative",
                __css: {
                    clear: "both"
                }
            }, wrapperProps), {
                children: OuterComponent
            }), "".concat(paragraph.id, "_").concat(i));
        })
    });
};


/***/ }),

/***/ 28590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ slugify; }
/* harmony export */ });
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31304);
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(slugify__WEBPACK_IMPORTED_MODULE_0__);

function slugify(text) {
    return slugify__WEBPACK_IMPORTED_MODULE_0___default()(text, {
        strict: true,
        lower: true,
        locale: "de"
    });
};


/***/ })

}]);